import { useEffect, useReducer, useState } from "react";
import { Navigation } from "./Navigation";
import {BounceLoader } from "react-spinners"



export function ContactUs(){
 
    const[isLoading,setIsLoading] = useState(false);
    const [state,dispatch] = useReducer(reducer, {First_name:"",Second_name:"",Contact:"",Email:"",Subject:"",Query:""}); 

   
   
   

    function reducer(state,action){
      if(action.type=="First_name"){

        return {First_name:action.nextName,Second_name:state.Second_name,Contact:state.Contact,Email:state.Email,Subject:state.Subject,Query:state.Query};
      }
     if(action.type=="Second_name"){
        return {First_name:state.First_name,Second_name:action.nextName,Contact:state.Contact,Email:state.Email,Subject:state.Subject,Query:state.Query};
     }
     if(action.type=="Contact"){
        return {First_name:state.First_name,Second_name:state.Second_name,Contact:action.nextName,Email:state.Email,Subject:state.Subject,Query:state.Query}; 
     }
      if(action.type=="Email"){
        return {First_name:state.First_name,Second_name:state.Second_name,Contact:state.Contact,Email:action.nextName,Subject:state.Subject,Query:state.Query};
      }
      if(action.type=="Subject"){
        return {First_name:state.First_name,Second_name:state.Second_name,Contact:state.Contact,Email:state.Email,Subject:action.nextName,Query:state.Query};
      }
      if(action.type=="Query"){

        return {First_name:state.First_name,Second_name:state.Second_name,Contact:state.Contact,Email:state.Email,Subject:state.Subject,Query:action.nextName};
      }
    }

    function handleInputChange(e){
    dispatch({
      type:e.target.name,
      nextName:e.target.value
     })

    }

  async function submit(){
   
    setIsLoading(true)
    try{
const response = await fetch("https://chemsolutionapp-v1-0.onrender.com/submit",
      {           
     method:"Post",
     mode:"cors",
     headers:{
        'Content-Type':"application/json"
     },
     body:JSON.stringify({'first_name':state.First_name,'second_name':state.Second_name,'contact':state.Contact,'email':state.Email,'subject':state.Subject,'body':state.Query}),

      }           

)

const data = await response.json();
if(response.status===400){
  setIsLoading(false)
  alert(data.error)
}
if(response.status===200){
  setIsLoading(false)
alert(data.success)

}
    }catch(ex){
      setIsLoading(false)
      alert(ex)}
  }

return(
<>
<Navigation/>

<div style={{zIndex:"20",position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"}}>{isLoading && (
          
          <BounceLoader  color="#0066ff" /> 
         
            )}</div>
              
<div style={{display:"grid",justifyContent:"center",marginTop:"20px"}}>
<div>    
<form >
<label style={{fontFamily:"serif"}}>First name:</label> <br/>   
<input   placeholder="First name (required)" name="First_name" value={state.First_name}  onChange={handleInputChange} required/><br/>
<label style={{fontFamily:"serif"}}>Second name:</label> <br/>
<input placeholder="Second name (required)" name="Second_name" onChange={handleInputChange} value={state.Second_name} required/><br/>
<lable style={{fontFamily:"serif"}}>Contact:</lable><br/>
<input placeholder="mobile number (required)" name ="Contact" onChange={handleInputChange} value={state.Contact} required/><br/>
<lable>Email:</lable><br/>
<input type="email" placeholder="email (optional)" name="Email" value={state.Email} onChange={handleInputChange}/><br/>
<label>Subject of query:</label><br/>
<textarea placeholder="Subject (required)" name="Subject" onChange={handleInputChange} value={state.Subject} required/><br/>
<label>Write your query:</label><br/>
<textarea placeholder="Query (required)" name="Query" onChange={handleInputChange} value={state.Query} required/><br/>


</form>
</div>
<div style={{marginTop:"20px",justifySelf:"center"}}>
    <button style={{cursor:"pointer"}} onClick={submit} >Submit</button>
</div>

</div>


</>



)



}